"use client"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { mediaQueries } from "ui"

export const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  ${mediaQueries.desktopM} {
    flex-direction: row;
  }
`
